import { useAtom } from "jotai";
import { useState } from "react";
import { useLeadMutation } from "web_myplann/Api/Finances/useLeadMutation";
import { balanceLeadSentAt } from "web_myplann/Finances/State/BalanceLeadAtom";

type Params = {
	income: number;
	expense: number;
};

export const useBalanceContactLead = ({ income, expense }: Params) => {
	const { mutate: makeLead, isPending } = useLeadMutation();
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [sentAt, setSentAt] = useAtom(balanceLeadSentAt);

	const onOpenDialog = () => setIsDialogOpen(true);
	const onCloseDialog = () => setIsDialogOpen(false);

	const onContactAgent = (onSuccess: () => void) => {
		makeLead(
			{ expense, income },
			{
				onSuccess: () => {
					setSentAt(new Date());
					onSuccess();
				},
			},
		);
	};

	return {
		isDialogOpen,
		isPending,
		sentAt,
		onOpenDialog,
		onCloseDialog,
		onContactAgent,
	};
};
